"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseScale = exports.getScale = void 0;
const circle_of_fifths_1 = require("../circle-of-fifths");
const notes_1 = require("../notes");
const blues_scale_1 = require("./blues-scale");
const diatonic_scale_1 = require("./diatonic-scale");
const pentatonic_scale_1 = require("./pentatonic-scale");
const scaleCache = {};
function getScale(tonic, mode = "major", scaleOrMode = "diatonic") {
    if (typeof tonic === "string") {
        tonic = (0, notes_1.getNote)(tonic);
    }
    const cacheKey = tonic.name + scaleOrMode + mode;
    let scale = scaleCache[cacheKey];
    if (!scale) {
        if (scaleOrMode === "diatonic") {
            scale = new diatonic_scale_1.DiatonicMusicScale(tonic, mode);
        }
        else if (scaleOrMode === "blues") {
            scale = new blues_scale_1.BluesScale(tonic, mode);
        }
        else if (scaleOrMode === "pentatonic") {
            scale = new pentatonic_scale_1.PentatonicScale(tonic, mode);
        }
        else {
            throw new Error("Invalid scale name: " + scaleOrMode);
        }
        scaleCache[cacheKey] = scale;
    }
    return scale;
}
exports.getScale = getScale;
/**
 * Parses a diatonic major or minor scale into a MusicScale object, or undefined if invalid
 * @param scale Name of a scale, where m=minor, M=major, e.g. C#m or C#M or just C#
 */
function parseScale(scale) {
    const re = /([A-G]{1}[#|b]?)([m,M]?)/.exec(scale);
    if (re && re[1]) {
        return getScale(re[1], re[2] === "m" ? "minor" : "major");
    }
    return undefined;
}
exports.parseScale = parseScale;
const ALL_MODE_NAMES = circle_of_fifths_1.MODE_NAMES.concat("major", "minor");
function isModeName(n) {
    return ALL_MODE_NAMES.indexOf(n) >= 0;
}
//# sourceMappingURL=index.js.map